export default __webpack_public_path__ + "static/media/scale-img.32ce4049.jpg";